import { Component, AfterViewInit, Renderer2 } from '@angular/core';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-invita-gana',
  standalone: true,
  imports: [NgbAccordionModule,],
  templateUrl: './invita-gana.component.html',
  styleUrls:['./invita-gana.component.scss',
    './css/main.css',
    './css/AnimateSection.css',
    './css/BaseSection.css',
    './css/FaqSection.css',
    './css/HeroSection.css',
    './css/InviteSection.css',
    './css/ParticipateSection.css',
    './css/ReferredSection.css',
  ]
})
export class InvitaGanaComponent implements AfterViewInit{

  constructor(private readonly renderer: Renderer2){

    gsap.registerPlugin(ScrollTrigger);

  }

  ngAfterViewInit() {
    this.loadGSAPScript();
  }

  loadScripts() {
    console.log("leer scripts");
    const script1 = document.createElement('script');
    script1.type='text/javascript';
 
    document.body.appendChild(script1);
   }

   loadGSAPScript() {
    console.log("Cargando GSAP y scripts de animación...");

    // Verificar si GSAP ya está cargado
    if (window['gsap']) {
      this.initializeAnimations();
      return;
    }

    // Cargar GSAP dinámicamente
    const gsapScript = this.renderer.createElement('script');
    gsapScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/gsap.min.js';
    gsapScript.onload = () => {
      console.log("GSAP cargado.");
      this.loadScrollTriggerScript();
    };
    this.renderer.appendChild(document.body, gsapScript);
  }

  loadScrollTriggerScript() {
    const scrollTriggerScript = this.renderer.createElement('script');
    scrollTriggerScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/ScrollTrigger.min.js';
    scrollTriggerScript.onload = () => {
      console.log("ScrollTrigger cargado.");
      this.initializeAnimations();
    };
    this.renderer.appendChild(document.body, scrollTriggerScript);
  }

  initializeAnimations() {
    console.log("Inicializando animaciones...");

 
  

    // Animación del logo Unipay
    gsap.to("#unipayLogo", {
      y: 2,
      duration: 3,
      repeat: -1,
      yoyo: true,
      ease: "power1.inOut"
    });

    // Animación de botones
    const buttons = document.querySelectorAll('.btn-dark, .btn-bases');
    buttons.forEach(button => {
      button.addEventListener('mouseenter', () => {
        gsap.to(button, { scale: 1.05, duration: 0.3, overwrite: true });
      });
      button.addEventListener('mouseleave', () => {
        gsap.to(button, { scale: 1, duration: 0.3, overwrite: true });
        gsap.to(button, {
          scale: 1.05,
          duration: 0.75,
          yoyo: true,
          repeat: -1,
          ease: "power1.inOut"
        });
      });
    });

    // Iniciar animación de botones
    gsap.to('.btn-dark, .btn-bases', {
      scale: 1.05,
      duration: 0.75,
      yoyo: true,
      repeat: -1,
      ease: "power1.inOut"
    });

    // Animación imágenes sección "Invita Aquí"
    gsap.to(".primer-plano", {
      x: 20,
      duration: 2,
      repeat: -1,
      yoyo: true,
      ease: "power1.inOut"
    });

    // Animación para elementos decorativos
    gsap.to('.bg-decoration', {
      x: 10,
      y: 10,
      duration: 3,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut"
    });

    // Animaciones de sección
    gsap.utils.toArray('.animate-section').forEach((section: any) => {
      const elements = section.querySelectorAll('h1, h2, h3, h4, h5, h6, p, img:not(.unipay-mano-image), svg:not(.unipay-mano-svg)');

      gsap.fromTo(section,
        { opacity: 0, y: -50 },
        {
          opacity: 1,
          y: 0,
          duration: 0.2,
          scrollTrigger: {
            trigger: section,
            start: "top 99%",
            end: "bottom 1%",
            toggleActions: "play none none reverse",
          }
        }
      );

      gsap.fromTo(elements,
        { opacity: 0, y: -20 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.1,
          scrollTrigger: {
            trigger: section,
            start: "top 90%",
            toggleActions: "play none none reverse",
          }
        }
      );
    });
    function animateHeroBubbles() {
      gsap.set('.hero-bubble', { opacity: 0, scale: 0.5 });

      gsap.to('.hero-bubble', {
        opacity: 0.7,
        scale: 1,
        duration: 1.5,
        ease: "elastic.out(1, 0.5)",
        stagger: { each: 0.2, from: "random" },
        onComplete: () => {
          startFloatingAnimation();
          animateDog();
        }
      });
    }


    function startFloatingAnimation() {
      gsap.to('.hero-bubble', {
        y: "random(-200, 200)",
        x: "random(-200, 200)",
        rotation: "random(-25, 25)",
        scale: "random(0.5, 1.5)",
        duration: "random(4, 7)",
        ease: "sine.inOut",
        repeat: -1,
        yoyo: true,
        stagger: { each: 0.3, from: "random" }
      });

     gsap.to('.hero-bubble', {
        opacity: "random(0.4, 1)",
        duration: "random(2, 4)",
        ease: "sine.inOut",
        repeat: -1,
        yoyo: true,
        stagger: { each: 0.5, from: "random" }
      });
    }

    function animateDog() {
      gsap.to('#hero-dog', {
        rotation: 5,
        x: 10,
        y: 0,
        duration: 2,
        ease: "sine.inOut",
        yoyo: true,
        repeat: -1
      });
    }

    function initDogAnimation() {
      const dogElement = document.getElementById('hero-dog');
      if (!dogElement) {
        console.error('No se encontró el elemento del perro');
        return;
      }
      animateDog();
    }

    // Llamar a las animaciones al cargar la página
    window.addEventListener('load', () => {
      console.log('Página cargada, inicializando animaciones');
      animateHeroBubbles();
      initDogAnimation();
    });
  }

}
